












































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { Button, Form } from 'element-ui';
import {
  InquiryFields,
  InquiryInput,
  PlaceFields,
  TransportationTypeEnum,
  IncotermsTypeEnum
} from '@/types/graphql/schemaTypes';
import UpsertCargo from '@/components/inquiry/upserts/Cargo.vue';
import UpsertExtra from '@/components/inquiry/upserts/Extra.vue';
import UpsertRoute from '@/components/inquiry/upserts/Route.vue';
import UpsertTransaction from '@/components/inquiry/upserts/Transaction.vue';
import omit from 'lodash/omit';
import { i18n } from '@/plugins/i18n';

@Component({
  components: {
    UpsertCargo,
    UpsertExtra,
    UpsertRoute,
    UpsertTransaction,
    'el-button': Button,
    'el-form': Form
  }
})
export default class InquiryDetailsView extends Vue {
  @Prop({ required: true }) inquiry!: InquiryFields;
  private arrivalValid = true;
  private departureValid = true;
  public inquiryInput: InquiryInput = {};
  public arrivalPlace: PlaceFields | null = null;
  public departurePlace: PlaceFields | null = null;
  public readOnly = true;
  public regulated = false;
  private rules = {
    incoterm: [
      {
        validator: this.incotermsValidation,
        required: true,
        message: i18n.t('validation.required'),
        trigger: 'change'
      }
    ]
  };

  private incotermsValidation(rule: any, value: any, callback: any) {
    // check if incoterms is not default value '' or invalid incotermEnum
    if (value === '' && !IncotermsTypeEnum[value]) {
      callback(new Error());
    } else {
      callback();
    }
  }

  private updateInquiryInput(inquiryInput: InquiryInput) {
    this.inquiryInput = { ...this.inquiryInput, ...inquiryInput };
  }

  private cancel() {
    this.inquiryInput = {};
    this.setReadOnly(true);
  }

  private setReadOnly(mode: boolean) {
    this.readOnly = mode;
  }

  // custome validation for address
  private addressValid() {
    this.departureValid = (
      !!this.inquiryInput.departureCustomerLocationId ||
      !!this.inquiryInput.departurePlaceId
    );
    this.arrivalValid = (
      !!this.inquiryInput.arrivalCustomerLocationId ||
      !!this.inquiryInput.arrivalPlaceId
    );
  }

  private submit() {
    // @ts-ignore
    this.$refs.quoteForm.validate((valid: boolean) => {
      this.addressValid();
      if (valid && (this.departureValid && this.arrivalValid)) {
        /**
         * cargoDescription is shared in 2 components
         * keep value regulated in sync by extracting if from object
        */
        if (this.inquiryInput.cargoDescription) {
          this.inquiryInput.cargoDescription.regulated = this.regulated;
        }
        this.$store.dispatch(
          'Inquiry/updateInquiry',
          { ...this.inquiryInput, id: this.$route.params.id }
        ).then(() => this.setReadOnly(true));
      }
    });
  }
}
